import React, { Component } from 'react';
import { connect } from 'react-redux';
import CallJoin from '../CallJoin';
import {
  isIOS,
  isAndroidChrome,
  getOpenInAppUrl,
} from '../../../helpers/serverRenderingUtils';
import { fetchStation, getStationIdFromProps } from '../../station';

const mapStateToProps = ({ browser, station, user }, routerProps) => ({
  doRequireStation: true,
  isIOS: isIOS(),
  isAndroidChrome: isAndroidChrome(),
  openInAppUrl: getOpenInAppUrl(
    `${routerProps.location.pathname}${routerProps.location.search}`
  ),
  station,
  user,
});

function CallJoinContainer(props) {
  return (
    <CallJoin {...props}>
      <p>
        has invited you to record a podcast episode with them - it's happening
        right now on Anchor!
      </p>
    </CallJoin>
  );
}

export default connect(mapStateToProps)(CallJoinContainer);
